/* eslint-disable react/function-component-definition */
import React from 'react';
import { Card } from 'flowbite-react';

// Cabecera degradada con borde redondeado solo arriba
const Header = ({ title }) => (
  <div className="rounded-r-full bg-gradient-to-r from-blue-500 to-blue-300 px-6 py-4">
    <h3 className="text-white font-bold text-xl tracking-wide uppercase">{title}</h3>
  </div>
);

// Círculo azul decorativo (como en tus imágenes)
const Dot = () => (
  <div className="w-3 h-3 bg-blue-400 rounded-full absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-1/2" />
);

// Tarjeta base para cada solución
const SolutionCard = ({ title, image, description, bullets, reverse = false }) => (
  <div className="relative">
    <Dot />
    <Card className="w-full overflow-hidden bg-white dark:bg-white border-none p-0">
      <Header title={title} />
      <div className={`flex flex-col md:flex-row ${reverse ? 'md:flex-row-reverse' : ''} gap-6 p-6`}>
        {image && (
          <div className="md:w-5/12 w-full flex-shrink-0 flex justify-center items-start">
            <img
              src={image}
              alt={title}
              className="rounded-lg object-contain max-h-64"
            />
          </div>
        )}
        <div className="md:w-7/12 w-full text-gray-700">
          <p className="mb-4 leading-relaxed text-sm md:text-base">{description}</p>
          {bullets?.length > 0 && (
            <ul className="list-disc list-inside space-y-1 text-sm md:text-base">
              {bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </Card>
  </div>
);

// Tarjetas específicas
export const BN100Card = () => (
  <SolutionCard
    title="BN100"
    image="https://img-cdn.hytera.com/iwov-resources/hytera/02_products/2_main_image/BN100_main.png_n.webp"
    description="La Voice Gateway Box integra radios móviles PoC y DMR, permitiendo intercomunicación rápida y eficiente. Dispositivo liviano, portátil y de fácil montaje y transporte."
    bullets={[
      'Comunicaciones de voz semidúplex.',
      'Conexión back-to-back entre radio móvil PMR y radio móvil PoC.',
    ]}
  />
);

export const IPTransitCard = () => (
  <SolutionCard
    title="IP TRANSIT"
    reverse
    image="https://dps2wxsijib8x.cloudfront.net/imagenes-generales/HYTERA/IPTRANSIT.png"
    description="Red económica y sencilla que amplía y complementa sistemas de radio bidireccional, manteniendo comunicaciones confiables entre ubicaciones geográficas."
    bullets={['DIGITAL DMO: amplía la cobertura con enlace de banda de frecuencia cruzada.']}
  />
);

export const SmartDispatchCard = () => (
  <SolutionCard
    title="SMARTDISPATCH PLUS"
    image="https://img-cdn.hytera.com/iwov-resources/hytera/02_products/2_main_image/ae_dmr_system_smart_dispatch_main.png_n.webp"
    description="Sistema de despacho DMR con funciones de comunicación, gestión y despacho. Diseño modular C/S y compatibilidad VoIP para gran escalabilidad."
    bullets={[
      'Despliegue flexible todo-en-uno y multinivel.',
      'Interfaz gráfica multilingüe.',
      'Gestión de órdenes, telemetría y OTAP.',
      'Servicios de voz, SMS y GPS.',
    ]}
  />
);

export const XPTCard = () => (
  <SolutionCard
    title="XPT"
    reverse
    image="https://dps2wxsijib8x.cloudfront.net/imagenes-generales/HYTERA/XPT.png"
    description="Infraestructura que conecta múltiples repetidoras para aumentar la capacidad. Asignación dinámica de llamadas y operación autónoma en Pseudotrunking."
    bullets={[
      'Asignación automática y dinámica de llamadas.',
      'Incremento de capacidad del sistema.',
      'Funcionamiento independiente ante fallos del Master.',
    ]}
  />
);
